import { render, staticRenderFns } from "./GuidedRegulationSubstanceRow.vue?vue&type=template&id=6093a890&scoped=true&"
import script from "./GuidedRegulationSubstanceRow.vue?vue&type=script&lang=js&"
export * from "./GuidedRegulationSubstanceRow.vue?vue&type=script&lang=js&"
import style0 from "./GuidedRegulationSubstanceRow.vue?vue&type=style&index=0&id=6093a890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093a890",
  null
  
)

export default component.exports